<template>
    <div class="main">
        <div class="main-title">
            <h2>新增（编辑）新闻信息</h2>
        </div>
        <form action="/admin.php?s=/News/add.html" method="post" name="form"
              class="form-horizontal">
            <input type="hidden" name="id" value="19">
            <div class="form-item">
                <label class="item-label">新闻名称</label>
                <div class="controls">
                    <input type="text" class="text input-large" id="title">
                </div>
            </div>

            <div class="form-item">
                <label class="item-label">标题图片<span class="check-tips">（上传图片尺寸132*85）</span></label>

                <div class="controls">
                    <input type="hidden" name="thepic" id="cover_id_thepic" value="99">
                    <div class="upload-img-box">
                        <div class="upload-pre-item"><img>
                        </div>
                    </div>
                    <input type="file" id="upload_picture_thepic">
                </div>
            </div>
            <div class="form-item">
                <label class="item-label">摘要<span class="check-tips">（不要超过75个汉字）</span></label>
                <div class="controls">
                    <label class="textarea">
                        <textarea id="brief"></textarea>
                    </label>
                </div>
            </div>
            <div class="form-item">
                <label class="item-label">详细介绍</label>
                <div class="controls"><textarea id="content"></textarea>
                    <input type="hidden" name="parse" value="0">
                </div>
            </div>
            <div class="form-item">
                <button class="btn submit-btn ajax-post" id="submit" type="submit"
                        target-form="form-horizontal">确 定
                </button>
                <button class="btn btn-return" onclick="javascript:history.back(-1);return false;">返
                    回
                </button>
            </div>
        </form>

    </div>
</template>
<script>

export default {
  data(){
    return {
      msg: '你好'
    }
  },
  created(){
          console.log(this.$route.params);
  }
}
</script>
<style scoped>
.main {
    min-height: 836px;
    background-color: #f6f6f6;
    padding: 20px;
}
.main-title h2 {
    float: left;
    font-size: 20px;
    font-weight: 400;
    color: #445566;
}
.main-title:after {
    clear: both;
}
.main-title:before, .main-title:after {
    display: table;
    content: "";
}
.form-horizontal .item-label {
    display: block;
    margin-right: 5px;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
}

.text {
    width: 220px;
    height: 20px;
    vertical-align: middle;
    padding: 4px;
    border: 1px solid #eeeeee;
    background-color: #fff;
    transition: all .3s linear;
}
</style>



// WEBPACK FOOTER //
// src/views/server_web/home/editNews.vue